<template lang="pug">
  div.view-app-account
    div.main-hero
      div.container
        h1 Change Password
    div.main-content
      div.container
        div.row
          div.col-md-8.col-lg-6
            app-form(method="POST", :endpoint="`auth/change-password`", :data="data")
              app-field(name="current_password", required)
                input.form-control(type="password", v-model="data.current_password")
              app-field(name="new_password", helpText="Your password must be 8-20 characters long, contain letters and numbers, and must not contain spaces, special characters, or emoji.", required)
                input.form-control(type="password", v-model="data.new_password")
              app-field(name="confirm_password", required)
                input.form-control(type="password", v-model="data.confirm_password")
              div.form-group
                app-submit Change Password
</template>

<script>
export default {
  data: () => ({
    data: {}
  })
}
</script>
